import { combineReducers } from 'redux';
import HelloWorld from './HelloWorld/reducer';
import Posts from './Posts/reducer';
import {routerReducer} from 'react-router-redux';

const rootReducer = combineReducers({
  HelloWorld,
  Posts,
  routing: routerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js